import type { TrackingContext } from '../types';

const SESSION_KEY = 'forteens.anonymous-session';

function makeSessionId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID();
  return `ft-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}

export function getAnonymousSessionId(): string {
  try {
    const existing = window.sessionStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const created = makeSessionId();
    window.sessionStorage.setItem(SESSION_KEY, created);
    return created;
  } catch {
    return makeSessionId();
  }
}

export function getTrackingContext(extra: Partial<TrackingContext> = {}): TrackingContext {
  const params = new URLSearchParams(window.location.search);
  const referralToken = params.get('utm_content')?.startsWith('ref_') ? params.get('utm_content')?.slice(4) ?? null : null;
  return {
    sessionId: getAnonymousSessionId(),
    utmSource: params.get('utm_source'),
    utmMedium: params.get('utm_medium'),
    utmCampaign: params.get('utm_campaign'),
    utmContent: params.get('utm_content'),
    utmTerm: params.get('utm_term'),
    referralToken,
    referrer: document.referrer || null,
    landingUrl: window.location.href,
    language: navigator.language || null,
    screenWidth: window.screen?.width ?? null,
    screenHeight: window.screen?.height ?? null,
    ...extra,
  };
}

export function calculateScrollPercent(): number {
  const documentHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
  const visibleHeight = window.innerHeight;
  if (documentHeight <= visibleHeight) return 100;
  return Math.min(100, Math.max(0, Math.round((window.scrollY / (documentHeight - visibleHeight)) * 100)));
}
